'use strict';

import React from 'react';
import classnames from 'classnames';

const Span = (props) => {
  let { className, len, offset, style, ...rest } = props;
  return (
    <div
      className={classnames(
        className,
        'span' + (len || 12),
        props['sm-len'] && 'sm-span' + props['sm-len'],
        offset && 'offset' + offset
      )}
      style={style}
      {...rest}
    >
      {props.children}
    </div>
  );
};

export default Span;
